import { normalizeOrderStatus } from '@/entities/order/model/normalizeOrderStatus'
import { resolveProductImageUrl } from '@/entities/product/lib/resolveProductImages'

function mapItemsPreview(items) {
  if (!Array.isArray(items)) {
    return []
  }

  return items.map((item) => ({
    title: String(item.title ?? ''),
    imageUrl: resolveProductImageUrl(item),
    quantity: Math.max(1, Math.floor(Number(item.quantity) || 1)),
  }))
}

export function mapClientOrderHistoryListItem(raw) {
  if (!raw) {
    return null
  }

  const restaurant = raw.restaurant ?? {}

  return {
    id: String(raw.id ?? ''),
    status: normalizeOrderStatus(raw.status),
    createdAt: raw.created_at ?? null,
    totalAmount: Number(raw.total_price ?? 0),
    restaurantTitle: String(restaurant.title ?? '').trim(),
    itemsPreview: mapItemsPreview(raw.items_preview),
    itemsCount: Math.max(0, Math.floor(Number(raw.items_count) || 0)),
  }
}

export function mapClientOrderHistoryList(rawList) {
  if (!Array.isArray(rawList)) {
    return []
  }

  return rawList.map(mapClientOrderHistoryListItem).filter(Boolean)
}
